/**
 * Do not edit directly
 */

export default "PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTggLjVhNy41IDcuNSAwIDEgMCA3LjUgNy41IDcuNTEgNy41MSAwIDAgMCAtNy41LTcuNXptMCAxNGE2LjUgNi41IDAgMSAxIDYuNS02LjUgNi41MSA2LjUxIDAgMCAxIC02LjUgNi41eiIvPjxwYXRoIGQ9Im04LjUgNGgtMXY0LjIxbDMuMTUgMy4xNC43LS43LTIuODUtMi44NnoiLz48L3N2Zz4=";